module.exports = __webpack_public_path__ + "static/media/camera.d0544544.jpeg";